import { SourceDataFieldType } from "@/api/dtos";

const sourceDataFieldTypeToText = (fieldType?: SourceDataFieldType) => {
    switch (fieldType) {
        case SourceDataFieldType.Checkbox:
            return 'Checkbox';
        case SourceDataFieldType.Ctcae:
            return 'CTCAE';
        case SourceDataFieldType.Date:
            return 'Date';
        case SourceDataFieldType.File:
            return 'File';
        case SourceDataFieldType.MultiSelect:
            return 'Multiselect';
        case SourceDataFieldType.MultilineText:
            return 'Multiline Text';
        case SourceDataFieldType.Numeric:
            return 'Numeric';
        case SourceDataFieldType.Radio:
            return 'Radio';
        case SourceDataFieldType.Select:
            return 'Select';
        case SourceDataFieldType.Hidden:
            return 'Hidden';
        case SourceDataFieldType.Text:
        default:
            return 'Text'
    }
}

export default sourceDataFieldTypeToText;